var JSONRequest = /** @class */ (function () {
    function JSONRequest() {
        this._headers = { "Content-Type": "application/json" };
    }
    Object.defineProperty(JSONRequest.prototype, "data", {
        get: function () {
            return this._data;
        },
        set: function (data) {
            this._data = data;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JSONRequest.prototype, "headers", {
        get: function () {
            return this._headers;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(JSONRequest.prototype, "body", {
        get: function () {
            return this._data;
        },
        enumerable: false,
        configurable: true
    });
    JSONRequest.prototype.set_credentials = function (token) {
        this._headers["Authorization"] = "Bearer " + token;
    };
    return JSONRequest;
}());
var create = function (entity) {
    var request = new JSONRequest();
    request.data = entity;
    return request;
};
var createEntityRequest = function (entity) {
    var request = new JSONRequest();
    request.data = { entity: entity };
    return request;
};
var createCollectionRequest = function (collection) {
    var request = new JSONRequest();
    request.data = { collection: collection };
    return request;
};
export { create, createEntityRequest, createCollectionRequest, JSONRequest };
